export default "<div *ngFor=\"let scenario of scenarios\" class=\"row margin\">\r\n  <amc-scenario [scenario]=\"scenario\"></amc-scenario>\r\n</div>\r\n";